import { toast } from "react-toastify";
import { RegionBranchOption, ReportingRegion } from "models/region-mapping";

// API only: the page dispatches the slice actions after these resolve.
const BASE = `${process.env.REACT_APP_API_URL}/region-mappings`;

export interface RegionMappingValues {
    code: string
    name: string
    branchIds: string[]
}

const send = async (url: string, method: string, body?: unknown) => {
    const res = await fetch(url, {
        credentials: 'include',
        method,
        headers: body ? { 'Content-Type': 'application/json' } : undefined,
        body: body ? JSON.stringify(body) : undefined,
    });
    if (!res.ok) {
        const errBody = await res.json().catch(() => null);
        throw new Error(errBody?.message ?? "Request failed");
    }
    return res.json();
}

export const getRegionMappings = async (): Promise<ReportingRegion[] | null> => {
    try {
        return (await send(BASE, 'GET')).data as ReportingRegion[];
    } catch (err: any) {
        toast.error(err.message ?? "Error getting regions");
        return null;
    }
}

export const getRegionMappingFormFields = async (): Promise<RegionBranchOption[] | null> => {
    try {
        return (await send(`${BASE}/form-fields`, 'GET')).data.branches as RegionBranchOption[];
    } catch (err: any) {
        toast.error(err.message ?? "Error getting branches");
        return null;
    }
}

export const submitCreateRegionMapping = async (vals: RegionMappingValues): Promise<ReportingRegion | null> => {
    try {
        const data = (await send(BASE, 'POST', vals)).data as ReportingRegion;
        toast.success("Region created.");
        return data;
    } catch (err: any) {
        toast.error(err.message ?? "Error creating region");
        return null;
    }
}

export const submitEditRegionMapping = async (id: string, vals: RegionMappingValues): Promise<ReportingRegion | null> => {
    try {
        const data = (await send(`${BASE}/${id}`, 'PATCH', vals)).data as ReportingRegion;
        toast.success("Region updated.");
        return data;
    } catch (err: any) {
        toast.error(err.message ?? "Error updating region");
        return null;
    }
}

export const deleteRegionMappingRequest = async (id: string): Promise<boolean> => {
    try {
        await send(`${BASE}/${id}`, 'DELETE');
        toast.success("Region deleted.");
        return true;
    } catch (err: any) {
        toast.error(err.message ?? "Error deleting region");
        return false;
    }
}
